import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SKIP_ERROR_NOTIFICATION } from '../../../core/error-handling/services/http-error-notification.interceptor';

export interface ConfiguracaoFrequencia {
  tipoRegistroFrequencia: 'TOTAL_FALTAS_AULAS' | 'TOTAL_FALTAS_DIA' | string;
  identificadorFrequencia: string;
  permiteFrequenciaTurmaExclusivaProgressaoParcial: boolean;
  percentualMinimoFrequencia?: number;
}

export interface ValidationResult {
  valido: boolean;
  mensagem?: string;
}

export interface TurmaValidacao {
  id: number;
  tipoAtendimento?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MobileFrequenciaValidationService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Busca configuração de frequência da turma
   * Endpoint: GET /api/frequencia/frequencia-aula/configuracao-frequencia/{idTurma}
   */
  getConfiguracaoTurma(idTurma: number): Observable<ConfiguracaoFrequencia> {
    return this.http.get<ConfiguracaoFrequencia>(
      `${this.apiUrl}/frequencia/frequencia-aula/configuracao-frequencia/${idTurma}`,
      // Componente já trata erros com mensagem adequada — suprimir toast global
      { context: new HttpContext().set(SKIP_ERROR_NOTIFICATION, true) }
    );
  }

  /**
   * Valida se configuração de frequência permite lançamento
   * Replica validações do AngularJS (frequencia.controller.js linha 636-656)
   */
  validarConfiguracao(
    config: ConfiguracaoFrequencia,
    turma: TurmaValidacao
  ): ValidationResult {
    // Validação 1: Tipo de frequência deve ser válido
    const isFaltasAulas = config.tipoRegistroFrequencia === 'TOTAL_FALTAS_AULAS';
    const isFaltasDias = config.tipoRegistroFrequencia === 'TOTAL_FALTAS_DIA';

    if (!isFaltasAulas && !isFaltasDias) {
      return {
        valido: false,
        mensagem:
          'Não é permitido lançar frequência para a forma de registro de frequência configurada para a turma'
      };
    }

    // Validação 2: Turmas de progressão parcial precisam de permissão específica
    if (
      turma.tipoAtendimento === 'ATENDIMENTO_PROGRESSAO_PARCIAL' &&
      !config.permiteFrequenciaTurmaExclusivaProgressaoParcial
    ) {
      return {
        valido: false,
        mensagem: 'Não é permitido lançar frequência para turmas de progressão parcial'
      };
    }

    return { valido: true };
  }

  /**
   * Helpers de tipo de frequência (replicando AngularJS)
   */
  isFaltasAulas(tipoRegistroFrequencia: string): boolean {
    return tipoRegistroFrequencia === 'TOTAL_FALTAS_AULAS';
  }

  isFaltasDias(tipoRegistroFrequencia: string): boolean {
    return tipoRegistroFrequencia === 'TOTAL_FALTAS_DIA';
  }
}
